function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import snakeCase from 'lodash.snakecase';
import React, { Component } from 'react';
import ReduxTextField from './reduxField';
import FormikTextField from './formik';
import TextFieldSelect from './textFieldSelect';
import { NormalInputContainer } from './styles';
import { NormalLabel, NormalTextInput } from './normalTextField';
import { jsx as ___EmotionJSX } from "@emotion/core";

var TextField = /*#__PURE__*/function (_Component) {
  _inherits(TextField, _Component);

  var _super = _createSuper(TextField);

  function TextField() {
    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocusedState: false,
      isHoveredState: false
    });

    _defineProperty(_assertThisInitialized(_this), "hoverElement", function () {
      _this.setState({
        isHoveredState: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unHoverElement", function () {
      _this.setState({
        isHoveredState: false
      });
    });

    return _this;
  }

  _createClass(TextField, [{
    key: "render",
    value: function render() {
      var isHoveredState = this.state.isHoveredState;

      var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          icon = _this$props.icon,
          hideLabel = _this$props.hideLabel,
          style = _this$props.style,
          outerStyle = _this$props.outerStyle,
          isFocused = _this$props.isFocused,
          help = _this$props.help,
          _this$props$meta = _this$props.meta,
          meta = _this$props$meta === void 0 ? {
        error: '',
        warning: '',
        touched: false,
        submitFailed: false,
        form: ''
      } : _this$props$meta,
          onClickAction = _this$props.onClickAction,
          actionButtonText = _this$props.actionButtonText,
          toolTip = _this$props.toolTip,
          link = _this$props.link,
          isLoading = _this$props.isLoading,
          outerClassName = _this$props.outerClassName,
          innerClassName = _this$props.innerClassName,
          subtitle = _this$props.subtitle,
          isResponsive = _this$props.isResponsive,
          inlineSubtitle = _this$props.inlineSubtitle,
          labelDirection = _this$props.labelDirection,
          props = _objectWithoutProperties(_this$props, ["label", "name", "placeholder", "value", "icon", "hideLabel", "style", "outerStyle", "isFocused", "help", "meta", "onClickAction", "actionButtonText", "toolTip", "link", "isLoading", "outerClassName", "innerClassName", "subtitle", "isResponsive", "inlineSubtitle", "labelDirection"]);

      var error = meta.error,
          warning = meta.warning,
          touched = meta.touched,
          submitFailed = meta.submitFailed;
      var isErrored = !!error;
      var isWarning = !!warning;
      var labelProps = {
        name: name,
        hideLabel: hideLabel,
        toolTip: toolTip,
        link: link,
        label: label,
        subtitle: subtitle,
        inlineSubtitle: inlineSubtitle,
        labelDirection: labelDirection
      };
      var inputProps = {
        name: name,
        isFocused: isFocused,
        isHoveredState: isHoveredState,
        isErrored: isErrored,
        isWarning: isWarning,
        touched: touched,
        innerClassName: innerClassName,
        isResponsive: isResponsive,
        icon: icon,
        submitFailed: submitFailed,
        placeholder: placeholder,
        value: value,
        onClickAction: onClickAction,
        style: style,
        actionButtonText: actionButtonText,
        isLoading: isLoading,
        help: help,
        error: error,
        onMouseOver: this.hoverElement,
        onMouseLeave: this.unHoverElement,
        warning: warning
      };
      return ___EmotionJSX(NormalInputContainer, {
        style: outerStyle,
        "data-test": snakeCase("".concat(meta.form, " ").concat(name)),
        "data-error": meta.error,
        className: outerClassName
      }, ___EmotionJSX(NormalLabel, labelProps), ___EmotionJSX(NormalTextInput, _extends({}, inputProps, props)));
    }
  }]);

  return TextField;
}(Component);

_defineProperty(TextField, "defaultProps", {
  variant: 'DEFAULT',
  link: false,
  disabled: false,
  slim: false,
  syncing: false,
  tall: false
});

TextField.defaultProps = {
  value: '',
  meta: {
    error: '',
    warning: ''
  },
  inlineSubtitle: false
};
export { TextField as default, ReduxTextField, TextFieldSelect, FormikTextField };